import RadioButtonWrapper from './RadioButtonWrapper';

const RadioButton = ({
    field: { name, value, onChange, onBlur },
    id,
    label,
}) => {
    return (
        <RadioButtonWrapper id={id} label={label}>
            <input
                name={name}
                id={id}
                type="radio"
                value={id}
                checked={id === value}
                onChange={(e) => {
                    onChange(e)
                }}
                onBlur={onBlur}
                className={'radio-button'}
            />
        </RadioButtonWrapper>
    )
}

export default RadioButton